<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="adaptationModal"
      title="详情"
      :visible.sync="dialogVisible"
      width="1400px"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="90px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工单编号">
            <el-input v-model="model.orders" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="model.materialNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称">
            <el-input v-model="model.materialDescription" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工单数量">
            <el-input v-model="model.orderNum" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划开工日期" prop="productStart">
            <el-date-picker
                v-model="model.productStart"
                disabled
                type="datetime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划完工日期" prop="productEnd">
            <el-date-picker
                v-model="model.productEnd"
                disabled
                style="width: 100%"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际开工时间" prop="actualStartTime">
            <el-date-picker
                v-model="model.actualStartTime"
                disabled
                style="width: 100%"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际完工时间" prop="completionTime">
            <el-date-picker
                v-model="model.completionTime"
                disabled
                style="width: 100%"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际入库时间" prop="warehousingTime">
            <el-date-picker
                v-model="model.warehousingTime"
                disabled
                style="width: 100%"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报工数量">
            <el-input v-model="model.sapConfirmQty" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入库数量">
            <el-input v-model="model.instockQty" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报修数量">
            <el-input v-model="model.repairNum" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName">
        <el-tab-pane label="订单组件" name="bomTab">
          <Table border stripe :columns="columns" :data="model.details"/>
        </el-tab-pane>
        <el-tab-pane label="工艺路线">
          <Table border stripe :columns="routingColumns" :data="model.routingList"/>
        </el-tab-pane>
        <el-tab-pane label="订单条码">
          <Table border stripe :columns="serialNoColumns" :data="model.serialNoList"/>
        </el-tab-pane>
        <el-tab-pane label="扫描详情">
          <Table border stripe :columns="confirmColumns" :data="model.confirmTotalVOList"/>
        </el-tab-pane>
        <el-tab-pane label="报修详情">
          <Table border stripe :columns="repairColumns" :data="model.repairList"/>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button v-if="!disabled" type="primary" @click="submitHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // import RouteTree from "@/views/ProductionManagement/ProductionPlan/RouteTree.vue";
  // import ProductCodeList from "../ProductionTask/ProductCodeList.vue";
  // import ProductProgress from "../ProductionTask/ProductProgress.vue";
  export default {
    components: {},
    data() {
      return {
        activeName: "bomTab",
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        workCenterList: [],
        treeData: [],
        treeContent: [],
        pageNum: 1,
        pageSize: 10,
        model: {
          productionOrderNo: "",
          materialNo: "",
          materialName: "",
          materialId: "",
          leftQuantity: "",
          routeId: "", // 产品工艺id
          routingName: "", // 产品工艺路线名称
          workCenterId: "",
          quantity: "",
          planStartTime: "",
          planFinishTime: "",
          bomList: [],
          routeProcessList: [],
          serialNoList: [],
          confirmTotalVOList:[],
        },
        ruleValidate: {
          quantity: [
            {required: true, message: "请输入派工数量", trigger: "blur"},
            {pattern: /^[1-9]\d*$/, message: "数字不合法,请输入大于0的整数!"},
          ],
          workCenterId: [{required: true, message: "请选择生产中心", trigger: "change"}],
          planStartTime: [{required: true, message: "请选择开工时间", trigger: "change"}],
          planFinishTime: [{required: true, message: "请选择完工时间", trigger: "change"}],
        },
        columns: [
          {
            title: "物料编号",
            key: "materialCode",
            width: 120,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialDescription",
            minWidth: 200,
            tooltip: true,
          },
          {
            title: "老物料号",
            key: "mappingMaterialNo",
            width: 140,
            tooltip: true,
          },
          {
            title: "库位",
            key: "positionNo",
            tooltip: true,
          },
          {
            title: "小仓位",
            key: "locationNo",
            tooltip: true,
          },
          {
            title: "数量",
            key: "requirementNum",
            width: 100,
            align: "center",
          },
          {
            title: "库存数量",
            key: "locationNumber",
            width: 100,
            align: "center",
          },
          {
            title: "已过帐数量",
            key: "postNum",
            width: 110,
            align: "center",
          },
          {
            title: "未过账数量",
            key: "unPostNum",
            width: 110,
            align: "center",
          },
          {
            title: "单位",
            key: "unit",
            width: 100,
            align: "center",
          },
        ],
        routingColumns: [
          {
            title: "工序",
            key: "operationNo",
            width: 120,
            tooltip: true,
          },
          {
            title: "名称",
            key: "procedureName",
            width: 120,
            align: "center",
          },
          {
            title: "工作中心",
            key: "standardCode",
            tooltip: true,
          },
          {
            title: "标准文本",
            key: "standardCode",
            width: 100,
            align: "center",
          },
          {
            title: "机器工时",
            key: "value2",
            width: 100,
            align: "center",
          },
          {
            title: "工时单位",
            key: "value2Unit",
            width: 100,
            align: "center",
          },
          {
            title: "人工工时",
            key: "value3",
            width: 100,
            align: "center",
          },
          {
            title: "工时单位",
            key: "value3Unit",
            width: 100,
            align: "center",
          },
        ],
        serialNoColumns: [
          {
            title: "序列号",
            key: "serialNo",
            width: 300,

          },
          {
            title: "创建日期",
            key: "createTime",
            width: 200,

          },
        ],
        confirmColumns: [
          {
            title: "工序",
            key: "station",
            width: 120,
          },
          {
            title: "工序名称",
            key: "stationName",
            width: 120,

          },
          {
            title: "扫描数量",
            key: "scanNum",
            width: 120,

          },
          {
            title: "完工数量",
            key: "completeNum",
            width: 120,
          },
        ],
        repairColumns:[
          {
            title: "报修时间",
            key: "faultTime",
            width: 200,
          },
          {
            title: "条码",
            key: "barcode",
            width: 300,
          },
          {
            title: "报修故障",
            key: "faultReporting",
            width: 250,

          },
          {
            title: "工序名称",
            key: "processName",
            width: 120,
          },
          {
            title: "维修时间",
            key: "repairTime",
            width: 200,
          },
          {
            title: "维修状态",
            key: "statusName",
            width: 120,
          },


        ],
      };
    },

    methods: {
      open(pkid, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        this.getData(pkid);
      },

      // 查询派工单详细信息
      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sapProductionOrders/${pkid}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
              this.model.details = this.model.details.map(item => {
                item.unPostNum = Number(item.requirementNum) - Number(item.postNum);
                return item;  
              });
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 根据产品工艺id查询生产中心
      getWorkCenterList(routeId) {
        this.$http.get("basic", `rtRoutes/material/workCenters/${routeId}`).then((res) => {
          if (res.success) {
            this.workCenterList = res.data;
          }
        });
      },

      //派工数量验证通过时获取生产BOM
      inputHandle() {
        this.$refs.form.validateField(["quantity"], (valid) => {
          // 验证通过
          if (!valid) {
            this.$http
              .get("basic", `taskDispatchBills/getbomlist?prodOrderNo=${this.model.productionOrderNo}&quantity=${this.model.quantity}`)
              .then((res) => {
                if (res.success) {
                  this.model.bomList = res.data;
                }
              });
          }
        });
      },

      // 获取更新后的产品工艺信息
      getUpdatedTable(data) {
        this.model.routeProcessList = data;
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.$moment(this.model.planFinishTime).valueOf() <= this.$moment(this.model.planStartTime).valueOf()) {
              this.$confirm("开工时间大于完工时间", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            if (!this.model.bomList.length) {
              this.$confirm("生产BOM不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.$http
              .put("basic", "taskDispatchBills", this.model)
              .then((res) => {
                if (res.success) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
